export default __webpack_public_path__ + "static/media/cleanproStep2-1.ecf4c5da.png";